import _ from 'lodash';
import { useEffect } from 'react';

function useInterval(block, millis, enabled = true, deps = []) {
  useEffect(() => {
    let id = null;
    let destructor = null;

    if (enabled && _.isFunction(block) && millis != null && millis > 0) {
      id = setInterval(() => {
        destructor = block.call(this);
      }, millis);
    }

    return () => {
      if (id != null) {
        clearInterval(id);
      }

      if (_.isFunction(destructor)) {
        destructor.call(this);
      }
    };
  }, [block, millis, enabled, ...deps]);
}

export { useInterval };
